import { calcMonthlyPayment } from './calcMonthlyPayment';
import { transformNumToString } from '../../common/utils';
import { ICalculatedValuesState, ICalculatorState } from '../types/calculator';

/** Функция для расчета расчетных значений **/
export const calculate = (initialValues: Omit<ICalculatorState, 'calculatedValues'>): ICalculatedValuesState => {
  /** Необходимая сумма */
  const necessarySum = Number((initialValues.price * (initialValues.necessarySumInPercent / 100)).toFixed(0));
  /** Комиссия за снижение ставки */
  const commissionByRate = Number(
    (initialValues.price * (initialValues.discountMortgagePercentBySeller * 0.01)).toFixed(0),
  );
  /** Стоимость квартиры в договоре */
  const flatPriceInDocument = initialValues.price - commissionByRate;
  /** Сумма первоначального взноса */
  const initialPaymentSum = necessarySum - commissionByRate;
  /** Сумма кредита */
  const creditSum = initialValues.price - necessarySum;
  /** Сумма Ежемесячного платёжа с меньшим процентом */
  const termInMonths = initialValues.term * 12;
  const rateMin = initialValues.mortgagePercentRate;
  const monthlyPaymentMinRate = Number(calcMonthlyPayment(creditSum, termInMonths, rateMin).toFixed(0));
  /** Сумма Ежемесячного платёжа с бОльшим процентом */
  const rateMax = initialValues.mortgagePercentRate + initialValues.discountMortgagePercent;
  const monthlyPaymentMaxRate = Number(calcMonthlyPayment(creditSum, termInMonths, rateMax).toFixed(0));
  /** Ставка без скидки **/
  const rateWithoutDiscount = transformNumToString(
    Number((initialValues.mortgagePercentRate + initialValues.discountMortgagePercent).toFixed(1)),
  );
  /** Скидка ежемесячного платежа **/
  const discountMonthlyPayment = monthlyPaymentMaxRate - monthlyPaymentMinRate;

  return {
    flatPriceInDocument,
    necessarySum,
    commissionByRate,
    initialPaymentSum,
    monthlyPaymentMinRate,
    monthlyPaymentMaxRate,
    creditSum,
    rateWithoutDiscount,
    discountMonthlyPayment,
  };
};
